import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Collapsible } from '@/components/ui/Accordion/Collapsible';
import { LinkButton } from '@/components/ui/Button/LinkButton';
import { UploadFileButton } from '@/components/ui/Form/UploadFile/UploadFileButton';
/**
 * クライアント：ファイル共有一覧のテーブル行コンテンツ
 * @constructor
 */
export const RfpClientFileTableInnerToggle = (props) => {
    const { className, files = [], isOpen, onClickFileLink, to } = props;
    return (_jsx(Collapsible, Object.assign({ isOpen: isOpen, transitionTime: 250 }, { children: _jsxs("div", Object.assign({ className: clsx('flex flex-col lg:flex-row gap-20 lg:items-end lg:flex-wrap', 'w-full', 'p-20', className) }, { children: [_jsx("div", Object.assign({ className: 'flex flex-col gap-8' }, { children: files === null || files === void 0 ? void 0 : files.map((file) => (_jsx(UploadFileButton, { fileName: file.name, id: file.id, onClickLink: onClickFileLink, textSize: 'sm' }, file.id))) })), _jsx(LinkButton, Object.assign({ className: 'ml-auto', color: 'navy', size: 'sm', to: to }, { children: "\u3084\u308A\u3068\u308A\u3092\u898B\u308B" }))] })) })));
};
